// Globals
import { useState } from 'react';

// Modules

// Components
import { StyledSender } from './SenderContainerStyles';
import { SendIcon } from '@/icons';

type TChatContainerWrapperProps = {
  disabled?: boolean;
  onSend: (message: string) => void;
};

export const SenderContainer = ({ onSend, disabled }: TChatContainerWrapperProps) => {
  const [value, setValue] = useState('');

  const handleSend = (value: string) => {
    const message = value.trim();
    if (!message) return;
    onSend(message);
    setValue('');
  };

  return (
    <StyledSender
      onSubmit={handleSend}
      disabled={disabled}
      value={value}
      onChange={setValue}
      placeholder="Type here..."
      autoSize={{ minRows: 1, maxRows: 5 }}
      actions={(_, info) => {
        const { SendButton } = info.components;
        return <SendButton icon={<SendIcon />} disabled={false} />;
      }}
    />
  );
};
